import { render, staticRenderFns } from "./UserDeal.vue?vue&type=template&id=7991c01d&"
import script from "./UserDeal.vue?vue&type=script&lang=js&"
export * from "./UserDeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports